/**
 * PDP: when the pointer is over the gallery (or anywhere outside the scrollable
 * product info column), route vertical wheel deltas to `.product__info-wrapper`
 * until that panel reaches its scroll extent, then allow normal page scroll.
 */
(function () {
  const MQ = '(min-width: 990px)';

  function getInfoWrapper(pdp) {
    return pdp.querySelector('.product__info-wrapper');
  }

  function isScrollable(el) {
    const epsilon = 2;
    return el.scrollHeight > el.clientHeight + epsilon;
  }

  function atTop(el) {
    return el.scrollTop <= 2;
  }

  function atBottom(el) {
    return el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
  }

  function onWheelCapture(event) {
    if (!window.matchMedia(MQ).matches) return;
    if (event.defaultPrevented) return;
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

    // Never hijack wheel while the cart drawer is interactive (open or mid-open).
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && (cartDrawer.classList.contains('active') || cartDrawer.classList.contains('animate'))) return;

    const deltaY = event.deltaY;
    if (!deltaY) return;

    // Listener is bound to `.product--pdp` only (not `document`), so we never
    // intercept global wheel events — avoids "page won't scroll" after overlays/modals.
    const pdp = event.currentTarget;
    if (!pdp || !pdp.classList || !pdp.classList.contains('product--pdp')) return;

    const info = getInfoWrapper(pdp);
    if (!info) return;

    if (info.contains(event.target)) return;

    if (!isScrollable(info)) return;

    if (deltaY > 0 && atBottom(info)) return;
    if (deltaY < 0 && atTop(info)) return;

    event.preventDefault();
    info.scrollTop += deltaY;
  }

  function attachWheelToPdp() {
    const pdp = document.querySelector('.template-product .product--pdp');
    if (!pdp) return;
    pdp.removeEventListener('wheel', onWheelCapture, { capture: true });
    pdp.addEventListener('wheel', onWheelCapture, { capture: true, passive: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachWheelToPdp, { once: true });
  } else {
    attachWheelToPdp();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector('.product--pdp')) attachWheelToPdp();
  });
})();
